<div>
  <div class="textDivider mb-2">
    <h4 class="textDividerContent font-size-24 font-weight-bold">
      Onboarded Users
    </h4>
  </div>
  <nz-table #basicTable [nzShowPagination]="false" [nzData]="listOfAllData"
    (nzCurrentPageDataChange)="currentPageDataChange($event)" class="table mb-4">
    <thead>
      <tr>
        <th nzShowCheckbox [(nzChecked)]="isAllDisplayDataChecked" [nzIndeterminate]="isIndeterminate"
          (nzCheckedChange)="checkAll($event)"></th>
        <th class="text-uppercase">Username</th>
        <th class="text-uppercase">Description</th>
        <th class="text-uppercase text-right">Start Date</th>
        <th class="text-uppercase">End Date</th>
        <th class="text-uppercase">Active</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of businessServiceOnboardings">
        <td nzShowCheckbox [(nzChecked)]="mapOfCheckedId[data.b2bid]"
          (nzCheckedChange)="refreshStatus()"></td>
        <td>
          {{data.fkUser}}
        </td>
        <td>
          {{data.description}}
        </td>
        <td class="text-right font-weight-bold">
          {{data.startDate}}
        </td>
        <td>
          {{data.endDate}}
        </td>
        <td>
          {{data.active}}
        </td>
  
        <td>
          <button type="button" *ngIf="!data.active" class="btn btn-outline-success mr-2 mb-2" (click)="togleOnboardedServiceAccept(data.b2bID)">Grant Access</button>
          <button type="button" *ngIf="data.active" class="btn btn-outline-warning mr-2 mb-2" (click)="togleOnboardedServiceReject(data.b2bID)">Revoke Access</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>